export default function(http) {
  return {
      tree(params){
        return http.json({
          url: `/house/info/tree`,
          params
        });
      },
      


  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/houseInfo.js